module.exports = __webpack_public_path__ + "img/service_design.745bab30.jpg";